// Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){var b=Array.prototype.slice,c=Array.prototype.splice,d={topSpacing:0,bottomSpacing:0,className:"is-sticky",wrapperClassName:"sticky-wrapper",center:!1,getWidthFrom:"",widthFromWrapper:!0,responsiveWidth:!1,zIndex:"inherit"},e=a(window),f=a(document),g=[],h=e.height(),i=function(){for(var b=e.scrollTop(),c=f.height(),d=c-h,i=b>d?d-b:0,j=0,k=g.length;j<k;j++){var l=g[j],m=l.stickyWrapper.offset().top,n=m-l.topSpacing-i;if(l.stickyWrapper.css("height",l.stickyElement.outerHeight()),b<=n)null!==l.currentTop&&(l.stickyElement.css({width:"",position:"",top:"","z-index":""}),l.stickyElement.parent().removeClass(l.className),l.stickyElement.trigger("sticky-end",[l]),l.currentTop=null);else{var o=c-l.stickyElement.outerHeight()-l.topSpacing-l.bottomSpacing-b-i;if(o<0?o+=l.topSpacing:o=l.topSpacing,l.currentTop!==o){var p;l.getWidthFrom?(padding=l.stickyElement.innerWidth()-l.stickyElement.width(),p=a(l.getWidthFrom).width()-padding||null):l.widthFromWrapper&&(p=l.stickyWrapper.width()),null==p&&(p=l.stickyElement.width()),l.stickyElement.css("width",p).css("position","fixed").css("top",o).css("z-index",l.zIndex),l.stickyElement.parent().addClass(l.className),null===l.currentTop?l.stickyElement.trigger("sticky-start",[l]):l.stickyElement.trigger("sticky-update",[l]),l.currentTop===l.topSpacing&&l.currentTop>o||null===l.currentTop&&o<l.topSpacing?l.stickyElement.trigger("sticky-bottom-reached",[l]):null!==l.currentTop&&o===l.topSpacing&&l.currentTop<o&&l.stickyElement.trigger("sticky-bottom-unreached",[l]),l.currentTop=o}var q=l.stickyWrapper.parent();l.stickyElement.offset().top+l.stickyElement.outerHeight()>=q.offset().top+q.outerHeight()&&l.stickyElement.offset().top<=l.topSpacing?l.stickyElement.css("position","absolute").css("top","").css("bottom",0).css("z-index",""):l.stickyElement.css("position","fixed").css("top",o).css("bottom","").css("z-index",l.zIndex)}}},j=function(){h=e.height();for(var b=0,c=g.length;b<c;b++){var d=g[b],f=null;d.getWidthFrom?d.responsiveWidth&&(f=a(d.getWidthFrom).width()):d.widthFromWrapper&&(f=d.stickyWrapper.width()),null!=f&&d.stickyElement.css("width",f)}},k={init:function(b){return this.each(function(){var c=a.extend({},d,b),e=a(this),f=e.attr("id"),h=f?f+"-"+d.wrapperClassName:d.wrapperClassName,i=a("<div></div>").attr("id",h).addClass(c.wrapperClassName);e.wrapAll(function(){if(0==a(this).parent("#"+h).length)return i});var j=e.parent();c.center&&j.css({width:e.outerWidth(),marginLeft:"auto",marginRight:"auto"}),"right"===e.css("float")&&e.css({float:"none"}).parent().css({float:"right"}),c.stickyElement=e,c.stickyWrapper=j,c.currentTop=null,g.push(c),k.setWrapperHeight(this),k.setupChangeListeners(this)})},setWrapperHeight:function(b){var c=a(b),d=c.parent();d&&d.css("height",c.outerHeight())},setupChangeListeners:function(a){if(window.MutationObserver){new window.MutationObserver(function(b){(b[0].addedNodes.length||b[0].removedNodes.length)&&k.setWrapperHeight(a)}).observe(a,{subtree:!0,childList:!0})}else window.addEventListener?(a.addEventListener("DOMNodeInserted",function(){k.setWrapperHeight(a)},!1),a.addEventListener("DOMNodeRemoved",function(){k.setWrapperHeight(a)},!1)):window.attachEvent&&(a.attachEvent("onDOMNodeInserted",function(){k.setWrapperHeight(a)}),a.attachEvent("onDOMNodeRemoved",function(){k.setWrapperHeight(a)}))},update:i,unstick:function(b){return this.each(function(){for(var b=this,d=a(b),e=-1,f=g.length;f-- >0;)g[f].stickyElement.get(0)===b&&(c.call(g,f,1),e=f);-1!==e&&(d.unwrap(),d.css({width:"",position:"",top:"",float:"","z-index":""}))})}};window.addEventListener?(window.addEventListener("scroll",i,!1),window.addEventListener("resize",j,!1)):window.attachEvent&&(window.attachEvent("onscroll",i),window.attachEvent("onresize",j)),a.fn.sticky=function(c){return k[c]?k[c].apply(this,b.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.sticky"):k.init.apply(this,arguments)},a.fn.unstick=function(c){return k[c]?k[c].apply(this,b.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.sticky"):k.unstick.apply(this,arguments)},a(function(){setTimeout(i,0)})});


var armCurrentCart = {}
var armCurrentCartXhr = null;

/* neccessary because when you repeat on Iphone more than once this:
   Free-products (collection) --> click checkout bottom button -> click browser back button(on contact info page) 
   it dow not fire 'pageshow' event.
*/
var backButton = 0;
$(window).on("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        restartProperties();
      	backButton = 1;
    }
});


function restartProperties() {
  $('a.checkout-button').removeClass('btn--loading');
}

$(function() {
  loadCurrentCart();
  checkoutCtaCheck();
  oneSignal();
  topSearchTest();
  commonFunc.uaLinker();
  fireWebsiteView();
  enableAnimalJewelryLink();
  checkUserCountry();
  $('[data-arm-function]').each(function(index){
    var funcName = $(this).attr('data-arm-function');
    $.proxy( window[funcName], $(this))();   
  });
});

function topSearchTest(){
  if ($("body.template-search").length > 0){
    return;
  }
  
  var topTest = commonFunc.getCookieTest('zz-top-search-test',2);
  if (topTest == 1) {
    commonFunc.sendAnalyticsEvent('top-search', 'top-search-yes');
    $('.arm-header-custom-search.arm-hide').removeClass('arm-hide');
  }
  else{
   commonFunc.sendAnalyticsEvent('top-search', 'top-search-no');
  }
}




function oneSignal(){
  window.OneSignal = window.OneSignal || [];
  OneSignal.push(function() {
    OneSignal.init({
      appId: "f6e0f7b7-581c-4621-8c95-249e0c43ae6a",
    });
  });
  
  
  OneSignal.push(function() {               
  OneSignal.isPushNotificationsEnabled().then(function(isEnabled) {
    if (isEnabled){
      console.log("Push notifications are enabled!");
    }
    else{
      $('.one-signal-container').removeClass('arm-hide');
      console.log("Push notifications are not enabled yet.");
    }
  });
      
  });
  
 OneSignal.push(function() {
  		// Occurs when the user's subscription changes to a new value.
     OneSignal.on('subscriptionChange', function (isSubscribed) {
       if (isSubscribed){
            $('.one-signal-container').addClass('arm-hide');
       }
     });
  });
  
}


function checkoutCtaCheck(){
  //files included
  // theme.js trigger this event ajaxCartLoaded
  // 00-arm-bottom-checkout-button.liquid, 00-arm-added-to-cart.liquid, cart.liquid, ajax-cart-template.liquid to add buttons
  // 00-arm-bundle.scss to add some small styles
  
  function has_special_item(cart){
    var has_special = false;
    var prod_length = cart.items.length;
    for (var i=0; i<prod_length; i++){
    	if (cart.items[i].handle.indexOf('diamond-kit') !== -1){
        	has_special = true;
        	break;
       	}
      
  	}
    return has_special;
  }
  
  function checkoutButtonLogic(cart){
    if(cart.item_count > 20) {
      $('.arm-checkout-msg-max-cta').removeClass('arm-hide');
      $('.arm-checkout-msg-cta').addClass('arm-hide');
      $('.arm-checkout-cta').addClass('arm-hide');
    }
    else{
      if(cart.item_count > 2 || cart.total_price >= 400 || has_special_item(cart)) {
          $('.arm-checkout-msg-cta').addClass('arm-hide');
          $('.arm-checkout-cta').removeClass('arm-hide');
          $('.arm-checkout-msg-max-cta').addClass('arm-hide');
      }
      else{
          $('.arm-checkout-msg-cta').removeClass('arm-hide');
          $('.arm-checkout-cta').addClass('arm-hide');
          $('.arm-checkout-msg-max-cta').addClass('arm-hide');
      }      
    }
  }
 
  
    checkoutCtaCheck.checkoutButtonLogic = checkoutButtonLogic;

	armCurrentCartXhr.done(function() {
      checkoutButtonLogic(armCurrentCart);
    });
  
  	$('body').on('ajaxCartLoaded', function(ev, cart){
        console.log("ajaxCartLoaded arm event");
        checkoutButtonLogic(cart);       
     });


}


function checkUserCountry(){
  if (commonFunc.getCookie('zzz_user_country')){
    return;
  }
 //commonFunc.setCookie(4320, 'zzz_user_country', "ZZ" ); // 3 days 

  
  $.ajax({
    url: 'https://api.ipgeolocation.io/ipgeo?apiKey=e34a1bbadab34b98949c03cd655f6aab',
    type: 'GET',
    dataType: 'json',
    success: function(info) {
      console.log("Set user country to :", info['country_code2']);
      commonFunc.setCookie(8640, 'zzz_user_country', info['country_code2'] ); // 6 days
      //commonFunc.setCookie(4320, 'zzz_user_country', "ZZ" ); // 3 days*/ 
    }
  });
}


function fireWebsiteView() {
  if ( !commonFunc.getCookie('zzz_website_view') ){
    window.dataLayer = window.dataLayer || []; 
  	dataLayer.push({'event': 'website_view'});
    commonFunc.setCookie(10080, 'zzz_website_view', '1'); // 7 days
  }
}

function enableAnimalJewelryLink() {
  if ( commonFunc.getCookie('zzz_animal_jewelry_view') ){
	$('.arm-hide.animal-jewelry-link').removeClass('arm-hide');
  }
}


function loadCurrentCart(){
  function callbackCart(data) {
    armCurrentCart = data;
  }
  
  
  armCurrentCartXhr = $.ajax({
    url: '/cart',
    success: callbackCart,
    dataType: 'json',
    cache: false
  });
  
}

function cartPage(){
  function updateCartForm(callbackFunc){
    var $cartForm = $('form.cart');
    $.ajax( {
      type: "POST",
      url: $cartForm.attr( 'action' ),
      data: $cartForm.serialize(),
      success: callbackFunc
    });
  }  

  $('body').on('click', '.js-qty__adjust', function(ev) {
    var callbackFunc = function(cart) {
      checkoutCtaCheck.checkoutButtonLogic(cart);
    }
    updateCartForm(callbackFunc);
  });
  
}


/* collection page */
function collectionPage(){
  var $self = this;
  
  function soldOut() {    
    $('div.is-sold-out a').addClass('force-no-pointer');
    $('.grid-product__sold-out').addClass('sold-out-new-style');
    $('div.is-sold-out a').on('click',function(ev){
      ev.preventDefault();
    });
  }
  
  function rememberCollection() {
	commonFunc.setCookie(60*24, 'collection-url-redirect', $self.attr('data-arm-collection-url') ); 
  }
    
  function animalJewelryCollection(){
    if ( $self.attr('data-arm-collection-id') == '401143696'){
    	commonFunc.setCookie(4320, 'zzz_animal_jewelry_view', 'yes' ); // 3 days 
    }
  }
  
  
  
  function loadCheckoutButton() {	
    armCurrentCartXhr.done(function() {
      if(armCurrentCart.item_count > 0) {
        $('.checkout-div-button').removeClass('arm-no-opacity');
        $('a.checkout-button').on('click', function(ev){
          if (backButton == 0){
       		$(this).addClass('btn--loading');
          }
     	});
      }
      else {
        $('.checkout-div-button').addClass('arm-hide');
      }
  	});    
    
    $('body').on('click', 'a.checkout-button', function(ev) {
      commonFunc.sendAnalyticsEvent('bottom_checkout_button', 'bottom_checkout_button_click');
    });
  }
  
  function initVariantOptions() {
    $('.grid-product').on('click, mouseover', 'button.variant_button_color', function(ev){
        commonFunc.sendAnalyticsEvent('show-color-variants', 'show-color-variants-click');
      	var $prod = $(this).parents('.grid-product');
		var $img = $prod.find('img.grid-product__image');
      	var $prodAnchors = $prod.find('a');
      	var $buttonCont = $(this).parents('.variant_button_cont');
      	$img.attr('src', $(this).attr('data-img'));
      	$img.attr('srcset', $(this).attr('data-img'));
      	$prodAnchors.attr('href', $(this).attr('data-href'));
      	$prod.find('div.variant_button_cont').not($buttonCont).removeClass('active');
      	$buttonCont.addClass('active');
    });

  }
  
  soldOut();
  rememberCollection();
  animalJewelryCollection();
  loadCheckoutButton();
  initVariantOptions();

}
/* end of collection page */

function showRelatedProducts() {
  var $self = this;

  function registerAnalyticsEvents(){
    $self.on('click', 'a.related_img_link', function(ev){
      commonFunc.sendAnalyticsEvent('show-related-products', 'show-related-products-click', 'show-related-products-click-img');
    });
             
	$self.on('click', 'a.related_text_link', function(ev){
      commonFunc.sendAnalyticsEvent('show-related-products', 'show-related-products-click', 'show-related-products-click-text');
    });
  }
  
  registerAnalyticsEvents();
}

function armTimer(){
  var $self = this;
  var collectionId = $('#CollectionSection header').attr('data-arm-collection-id');
  
  function startTimer(duration, display) {
    var start = Date.now(),
      diff,
      minutes,
      seconds;
    function timer() {
      diff = duration - (((Date.now() - start) / 1000) | 0);

      hours = (diff / 3600) | 0;
      minutes = ( (diff % 3600) / 60) | 0;
      seconds = ((diff % 3600) % 60) | 0;

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.html(hours + '<span class="time_letter">h</span> ' + minutes + '<span class="time_letter">min</span> ' + seconds + '<span class="time_letter">s</span>');

      if (diff <= 0) {
        start = Date.now() + 1000;
      }
    };
    timer();
    setInterval(timer, 1000);
  }
  
  function getTimerSeconds() {
    var finishDate = window.finishDate || new Date(Date.UTC(2016, 9, 25, 7, 0, 0, 0));
    var now = new Date();
    if (now > finishDate && window.noRestartTimer) {
      return 0;
    }
    
    while (now - finishDate > 0) {
      finishDate = new Date(finishDate.getTime() + 24*60*60*1000);
    }
    var finishDate_seconds = finishDate.getTime() / 1000;
    var now_seconds = now / 1000;
    return finishDate_seconds - now_seconds;
  }
  
  return;
  if ( ['428206352', '401143696'].indexOf(collectionId) == -1) {
    return;
  }  
  
  /*var timerTest = commonFunc.getCookieTest('zz-timer-test',5);
  if (timerTest == 1) {
    commonFunc.sendAnalyticsEvent('timer-test', 'timer-test-no');
    return
  }*/
  
  $self.removeClass('arm-hide');
  var timeSeconds = getTimerSeconds();
  startTimer(timeSeconds, $self.find('.timer_widget'));
  var hours = parseInt(timeSeconds / 60 / 60);
  var range = parseInt(hours / 6);
  if (hours < 1) {
    range = "last_hour";
  }
  $self.sticky({topSpacing:0, zIndex:10});
  commonFunc.sendAnalyticsEvent('timer-test', 'timer-test-yes', 'timer-test-sticky-yes');
  
}


function wholesalePage(){
  $( "form" ).submit(function( event ) {
    commonFunc.sendAnalyticsEvent('wholesale-page', 'wholesale-submit-form');
  });
  
  $("input[type='submit']").on('click', function( event ) {
    commonFunc.sendAnalyticsEvent('wholesale-page', 'wholesale-submit-button-click');
  });
}


function globalPage(){
  $('.refersio-link').on('click', function(ev){
   	window.dataLayer = window.dataLayer || []; 
    dataLayer.push({'event': 'goToRefersio'});
  });
}

function headerSection(){
  var $self = this;
  $('button.site-nav__link').on('click', function(ev){
    if ( $(this).find('.icon-hamburger').length == 1 ){
    	commonFunc.sendAnalyticsEvent('menu-action-hamburger', 'hamburger-click');
    }
  });
  
  $self.on('click', 'a.site-nav__link', function(ev){
    commonFunc.sendAnalyticsEvent('menu-action-root', $(this).text().trim());
  });
  
  $('div.mobile-nav__has-sublist a.mobile-nav__link').on('click', function(ev){
    commonFunc.sendAnalyticsEvent('menu-action-root', $(this).text().trim());
  });
  
  $('div.mobile-nav__toggle button.mobile-nav__toggle-btn').on('click', function(ev){
    var parentCat = $(this).parents('div.mobile-nav__has-sublist').find('a.mobile-nav__link').text().trim();
    commonFunc.sendAnalyticsEvent('menu-action-expand', parentCat);
  });
  
  
  $self.on('click', 'a.site-nav__dropdown-link', function(ev){
    var parentCat = $(this).parents('li.site-nav__item').find('a.site-nav__link').text().trim();
    var me = $(this).text().trim();
    commonFunc.sendAnalyticsEvent('menu-action-children', parentCat, me);
  });
  
  $('ul.mobile-nav__sublist').on('click', 'a.mobile-nav__link', function(ev){
    var parentCat = $(this).parents('li.mobile-nav__item').find('div.mobile-nav__has-sublist a.mobile-nav__link').text().trim();
    var me = $(this).text().trim();        
    commonFunc.sendAnalyticsEvent('menu-action-children', parentCat, me);

  });
    
  //semi-copied from theme.js  
  $('#shopify-section-drawer-menu span.mobile-nav__link').on('click', function() {
    var toggleButton = $(this).next('.mobile-nav__toggle').children('button.mobile-nav__toggle-btn');
    var currentlyExpanded = toggleButton.attr('aria-expanded');
    var toggleState = false;
    // Updated aria-expanded value based on state pre-click
    if (currentlyExpanded === 'true') {
      toggleButton.attr('aria-expanded', 'false');
    } else {
      toggleButton.attr('aria-expanded', 'true');
      toggleState = true;
    }
    // Toggle class that expands/collapses sublist
    toggleButton.closest('.mobile-nav__has-sublist').toggleClass('mobile-nav--expanded', toggleState);
  });

}

function initUpsellFamily() {
  // Some global vars are initialized on 00-arm-upsell-family.liquid
  
  window.upsellFamilyMod = (function () { 
    
    var addItemToCart = function(variantId, callback){      
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {quantity: 1, id: variantId},
          success: callback,
          dataType: 'json'
        });    
    };
    
    var updateFamilyPriceAndButton = function(){
      var totalPrice = 0;
      var enabledProd = 0;
      $('.pr_similar_check input[type="checkbox"]:checked').each(function () {
        enabledProd += 1;
        totalPrice += parseInt($(this).parents('.pr_similar_check').attr('data-price'));
      });
      $('.total_family_price .price_num').html('$' + (totalPrice/100).toFixed(2));

      var buttonTxt = 'Add to Cart';
      if (enabledProd == 2){
        buttonTxt = 'Add both to Cart';
      }
      else if (enabledProd == 3){
        buttonTxt = 'Add all three to Cart';
      }
      else if(enabledProd > 3){
        buttonTxt = 'Add all to Cart';
      }  

      $('button.add_to_cart_family').html(buttonTxt);
    };

    var updateUpsellProductDom = function(prodId, variantId){
      var productPackLength = window.productPack.length;
      var prod = null;
      var variant = null;
      for (var i=0; i<productPackLength; i++){
        if (window.productPack[i].id == prodId){
          prod = window.productPack[i];
          var variantLength = prod.variants.length;
          for (var j=0 ; j<variantLength; j++){
            if (prod.variants[j].id == variantId){
              variant = prod.variants[j];
            }
          }
          break
        }
      }
      var newImgSrc = window.variantFamily[prodId][variantId]['imgSrc'];
      var newUrl = '/products/' + prod.handle + '?variant=' + variant.id;
      var domProdImg = $(".pr_similar_photo[data-product-id='" + prodId + "']");
      var domProdCheck = $(".pr_similar_check[data-product-id='" + prodId + "']");

      domProdImg.find('a').attr('href', newUrl);
      domProdImg.find('img').attr('src', newImgSrc);
      domProdImg.attr('data-variant-id', variantId);
      domProdCheck.attr('data-price', variant.price).attr('data-variant-id', variantId);
      domProdCheck.find('.similar_check_price').html('$' + (variant.price/100).toFixed(2));
      domProdCheck.find('input[type="checkbox"]').prop("checked", true).attr('value', 'variant_'+variantId);
      domProdCheck.find('a.similar_title').attr('href', newUrl);
      
      //modal update
      var $upsellModalItem = $('#arm_upsell_modal .modal_upsell_item[data-product-id="' + prodId +'"');
      $upsellModalItem.attr('data-variant-id', variantId);
      $upsellModalItem.find('.modal_upsell_item_img_container img').attr('src', newImgSrc);
    };

    var attachFamilyListeners = function(){
      function fixPlusSign(){
          $('.family_plus_sign').hide();
          var howMany = $('.pr_similar_photo:visible').length;
          if (howMany > 1){
            for (var i=0; i < howMany-1; i++){
              $('.pr_similar_photo:visible:eq(' + i + ')').next('.family_plus_sign').show();
            }
          }
      }

      function moveAlong() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.arm_queue.length) {
          var request = Shopify.arm_queue.shift();
          addItemToCart(request.variantId, moveAlong);
        }
        // If the queue is empty, we will redirect to the cart page.
        else {
          window.armProductPage.redirectCategory(true);
        }
      }
            
      function registerATCFamilyEvents() {
        var added_items = '|';
        $('.pr_similar_check input[type="checkbox"]:checked').each(function () {
        	var addedItemTitle = $(this).parents('.pr_similar_check').find('.similar_title').text().toLowerCase()
            if (addedItemTitle.indexOf('necklace')!=-1){
              added_items +='necklace|';
            }
          	if (addedItemTitle.indexOf('bracelet')!=-1){
              added_items +='bracelet|';
            }
          	if (addedItemTitle.indexOf('earrings')!=-1){
              added_items +='earrings|';
            }
        });
        commonFunc.sendAnalyticsEvent('added_family_to_cart', added_items);

        
      }

      $('.pr_similar_check input[type="checkbox"]').on('change', function(ev){
        updateFamilyPriceAndButton();
        var variantId = $(this).val().replace('variant_', '');
        var $photoCont = $('.pr_similar_photo[data-variant-id="' + variantId + '"]');
        if ($(this).is(':checked')) {
          $(this).parents('.pr_similar_check').find('.similar_check_text_container').removeClass('family_text_disabled');
          $photoCont.show();         
        }
        else{
          $(this).parents('.pr_similar_check').find('.similar_check_text_container').addClass('family_text_disabled');
          $photoCont.hide();
        }

        fixPlusSign();

      });

      $('button.add_to_cart_family').on('click', function(ev){
        commonFunc.sendAnalyticsEvent('added_family_to_cart', 'added_family_to_cart-yes');
        Shopify.arm_queue = [];
        $('.pr_similar_check input[type="checkbox"]:checked').each(function () {
          Shopify.arm_queue.push( {
            variantId: $(this).val().split('_')[1],
            quantity: 1
          });
        });

        moveAlong();
        registerATCFamilyEvents();
      });
    }
    
    function attachAnalyticsEvents() {
      $('.upsell_family').on('click', 'a', function(ev) {
        commonFunc.sendAnalyticsEvent('upsell_family_link', 'upsell_family_link_click_yes');
      });      
    }
    
    function attachModalListeners($item){
      function atc_callback($button, $upsellItem, $spanTextAdded){
        $button.removeClass('btn--loading');
        $spanTextAdded.fadeIn("slow");
        var $buttonDontWant = $('.modal_upsell_item_dont_want:visible');
        if ($buttonDontWant.length > 0){
          $buttonDontWant.fadeOut("slow", function() {
            $('.modal_upsell_item_continue').fadeIn('slow');
          });
        }   
      }
      
      $('button.modal_upsell_item_info_atc').on('click', function(ev){
        var $self = $(this);
        var $modalUpsellItem = $(this).parents('.modal_upsell_item');
       	var $spanTextAdded = $modalUpsellItem.find('span.modal_upsell_added_msg');
        var variantId = $modalUpsellItem.attr('data-variant-id');
        commonFunc.sendAnalyticsEvent('upsell_family_modal', 'upsell_family_modal_added');
        $self.addClass('btn--loading');
        $spanTextAdded.hide();
        addItemToCart(variantId, function(){ atc_callback($self, $modalUpsellItem, $spanTextAdded) } );
      });
      
    }


    return {
      // called from theme.js:_onSelectChange
      variantChanged: function (variant) {
        console.log("me llaman");
        updateUpsellProductDom(window.currentProdId, variant.id);	
        var family = window.variantFamily[window.currentProdId][variant.id]['familyName'];     
        for (var prodId in window.variantFamily) {
          if (window.variantFamily.hasOwnProperty(prodId)) {
            if (prodId == window.currentProdId){
              continue;
            }
            for (var variantId in window.variantFamily[prodId]) {
              if (window.variantFamily[prodId].hasOwnProperty(variantId) && window.variantFamily[prodId][variantId]['familyName'] == family) {
                updateUpsellProductDom(prodId, variantId);	
                break;
              }
            }
          }
        }
        updateFamilyPriceAndButton();

      },
      initMod: function () {
        attachFamilyListeners();
        attachAnalyticsEvents();
        attachModalListeners();

      }
    };

  })();
  
  window.upsellFamilyMod.initMod();
}

function productPage() {
    
  window.armProductPage = (function () { 
    return {
      // called from theme.js and from this file
      redirectCategory: function (isRedirectSuffix) {
        // armRelatedCollectionUrl is set on product-template.liquid
        var collectionRedirect = commonFunc.getCookie('collection-url-redirect');
        if (!collectionRedirect && typeof armRelatedCollectionUrl != 'undefined' && armRelatedCollectionUrl){
            collectionRedirect = '/collections/' + armRelatedCollectionUrl;
        }
        if(!collectionRedirect){
          collectionRedirect = '/cart';
        }
        
        var redirectSuffix = '';
        if (isRedirectSuffix){
			redirectSuffix = '?added_to_cart=true&session_id=' + commonFunc.randomIntFromInterval(1,1000000)
        }
        window.location = collectionRedirect + redirectSuffix;
      },
    };
  })();
  
  
  // ATC event
  $('button.add_to_cart_family, button#AddToCart').on('click', function(ev){
    window.dataLayer.push({'event': 'atc_ev'});
  });
  
}